module.exports = {
  expand: 'login/expand',
  login: 'login/login',
  password: 'login/password',
  button: 'login/button',
  errorContainer: 'login/errorContainer'
}
